/**
 * @property id UUIDv4
 * @property createdAt ISO 8601 format
 * @property duration in milliseconds
 */
interface Base {
	id: string;
}

export enum ProcessStatus {
	IDLE,
	RUNNING,
	DONE,
	CANCELLED,
	ERROR,
}

export interface ProcessStep extends Base {
	status: ProcessStatus;
	description: string;
	children: ProcessStep[];
	createdAt: string | null;
	duration: number | null;
}

export interface Process extends Base {
	title: string;
	root: ProcessStep;
}

export interface Progress {
	current: number;
	total: number | null;
}

export interface ScreenCapture {
	id: number;
	caption: string;
	uri: string;
	timestamp: string;
	action_description: string;
	action_type: string;
}
